module.exports = __webpack_public_path__ + "static/media/people-3.42385d5f.jpg";